// // // import React, { useState, useEffect } from 'react';
// // // import { useDispatch, useSelector } from 'react-redux';
// // // import { useHistory } from 'react-router-dom';
// // // import { useSnackbar } from 'react-simple-snackbar';
// // // import {
// // //   Container,
// // //   Typography,
// // //   Button,
// // //   TextField,
// // //   FormControl,
// // //   InputLabel,
// // //   Select,
// // //   MenuItem,
// // //   Table,
// // //   TableBody,
// // //   TableCell,
// // //   TableContainer,
// // //   TableHead,
// // //   TableRow,
// // //   Paper,
// // // } from '@material-ui/core';
// // // import Autocomplete from "@material-ui/lab/Autocomplete";

// // // import { makeStyles } from '@material-ui/core/styles';
// // // import moment from 'moment';
// // // import { getAllSuppliers } from '../../actions/supplierActions';
// // // import { updatePurchase } from '../../actions/purchaseActions';
// // // import { getPurchases } from '../../actions/purchaseActions';

// // // const useStyles = makeStyles((theme) => ({
// // //   root: {
// // //     padding: theme.spacing(3),
// // //   },
// // //   formControl: {
// // //     margin: theme.spacing(1),
// // //     minWidth: 150,
// // //   },
// // //   table: {
// // //     minWidth: 650,
// // //   },
// // // }));

// // // const SupplierDues = () => {
// // //   const classes = useStyles();
// // //   const dispatch = useDispatch();
// // //   const history = useHistory();
// // //   const [openSnackbar] = useSnackbar();
// // //   const suppliers = useSelector((state) => state.suppliers.suppliers);
// // //   const purchases = useSelector((state) => state.purchases.purchases);
// // //   const [selectedSupplier, setSelectedSupplier] = useState(null);
// // //   const [dueAmount, setDueAmount] = useState(0);
// // //   const [paymentAmount, setPaymentAmount] = useState('');
// // //   const [paymentMethod, setPaymentMethod] = useState('');
// // //   const [paymentNote, setPaymentNote] = useState('');
// // //   const user = JSON.parse(localStorage.getItem('profile'));

// // //   useEffect(() => {
// // //     dispatch(getAllSuppliers());
// // //     dispatch(getPurchases());
// // //   }, [dispatch]);

// // //   useEffect(() => {
// // //     if (selectedSupplier) {
// // //       const supplierPurchases = purchases.filter(
// // //         (p) => p.supplier?.id === selectedSupplier.id && p.supplierDue > 0
// // //       );
// // //       const totalDue = supplierPurchases.reduce((sum, p) => sum + p.supplierDue, 0);
// // //       setDueAmount(totalDue);
// // //     } else {
// // //       setDueAmount(0);
// // //     }
// // //   }, [selectedSupplier, purchases]);

// // //   const handlePayment = async () => {
// // //     if (!selectedSupplier || !paymentAmount || !paymentMethod) {
// // //       openSnackbar('Please fill all required fields');
// // //       return;
// // //     }

// // //     const amountToPay = parseFloat(paymentAmount);
// // //     if (amountToPay <= 0 || amountToPay > dueAmount) {
// // //       openSnackbar('Invalid payment amount');
// // //       return;
// // //     }

// // //     // Find all purchases with dues for this supplier
// // //     let remainingPayment = amountToPay;
// // //     const supplierPurchases = purchases
// // //       .filter((p) => p.supplier?.id === selectedSupplier.id && p.supplierDue > 0)
// // //       .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt)); // Pay oldest first

// // //     for (const purchase of supplierPurchases) {
// // //       if (remainingPayment <= 0) break;

// // //       const currentDue = purchase.supplierDue;
// // //       const paymentForThisPurchase = Math.min(remainingPayment, currentDue);

// // //       const newPaymentRecord = {
// // //         amountPaid: paymentForThisPurchase,
// // //         datePaid: new Date(),
// // //         paymentMethod,
// // //         note: paymentNote,
// // //         paidBy: user?.result?.name || 'Unknown',
// // //       };

// // //       const updatedDue = currentDue - paymentForThisPurchase;
// // //       const newStatus =
// // //         updatedDue === 0 ? 'Paid' : updatedDue < purchase.total ? 'Partially Paid' : 'Unpaid';

// // //       const updatedPurchase = {
// // //         ...purchase,
// // //         supplierDue: updatedDue,
// // //         status: newStatus,
// // //         paymentRecords: [...purchase.paymentRecords, newPaymentRecord],
// // //         totalAmountReceived: (purchase.totalAmountReceived || 0) + paymentForThisPurchase,
// // //       };

// // //       await dispatch(updatePurchase(purchase.id, updatedPurchase));
// // //       remainingPayment -= paymentForThisPurchase;
// // //     }

// // //     openSnackbar('Payment recorded successfully');
// // //     setPaymentAmount('');
// // //     setPaymentMethod('');
// // //     setPaymentNote('');
// // //     dispatch(getPurchases()); // Refresh purchases
// // //   };

// // //   const suppliersProps = {
// // //     options: suppliers,
// // //     getOptionLabel: (option) => option.name || '',
// // //   };

// // //   return (
// // //     <Container className={classes.root}>
// // //       <Typography variant="h4" gutterBottom>
// // //         Supplier Dues Management
// // //       </Typography>
// // //       <Autocomplete
// // //         {...suppliersProps}
// // //         value={selectedSupplier}
// // //         onChange={(event, value) => setSelectedSupplier(value)}
// // //         renderInput={(params) => (
// // //           <TextField {...params} label="Select Supplier" variant="outlined" />
// // //         )}
// // //       />
// // //       {selectedSupplier && (
// // //         <>
// // //           <Typography variant="h6" style={{ marginTop: '20px' }}>
// // //             Current Due: {dueAmount.toFixed(2)}
// // //           </Typography>
// // //           <TextField
// // //             label="Payment Amount"
// // //             type="number"
// // //             value={paymentAmount}
// // //             onChange={(e) => setPaymentAmount(e.target.value)}
// // //             variant="outlined"
// // //             style={{ marginTop: '20px', marginRight: '10px' }}
// // //           />
// // //           <FormControl variant="outlined" className={classes.formControl}>
// // //             <InputLabel>Payment Method</InputLabel>
// // //             <Select
// // //               value={paymentMethod}
// // //               onChange={(e) => setPaymentMethod(e.target.value)}
// // //               label="Payment Method"
// // //             >
// // //               <MenuItem value="Cash">Cash</MenuItem>
// // //               <MenuItem value="Online">Online</MenuItem>
// // //             </Select>
// // //           </FormControl>
// // //           <TextField
// // //             label="Payment Note"
// // //             value={paymentNote}
// // //             onChange={(e) => setPaymentNote(e.target.value)}
// // //             variant="outlined"
// // //             style={{ marginTop: '20px', width: '300px' }}
// // //           />
// // //           <Button
// // //             variant="contained"
// // //             color="primary"
// // //             onClick={handlePayment}
// // //             style={{ marginTop: '20px', backgroundColor: '#ef7f1a' }}
// // //           >
// // //             Record Payment
// // //           </Button>
// // //           <Typography variant="h6" style={{ marginTop: '30px' }}>
// // //             Payment History
// // //           </Typography>
// // //           <TableContainer component={Paper}>
// // //             <Table className={classes.table}>
// // //               <TableHead>
// // //                 <TableRow>
// // //                   <TableCell>Purchase ID</TableCell>
// // //                   <TableCell>Date</TableCell>
// // //                   <TableCell>Amount Paid</TableCell>
// // //                   <TableCell>Payment Method</TableCell>
// // //                   <TableCell>Note</TableCell>
// // //                   <TableCell>Paid By</TableCell>
// // //                 </TableRow>
// // //               </TableHead>
// // //               <TableBody>
// // //                 {purchases
// // //                   .filter((p) => p.supplier?.id === selectedSupplier.id)
// // //                   .flatMap((p) =>
// // //                     p.paymentRecords.map((record, index) => (
// // //                       <TableRow key={`${p.id}-${index}`}>
// // //                         <TableCell>{p.purchaseNumber}</TableCell>
// // //                         <TableCell>{moment(record.datePaid).format('MMM Do YYYY')}</TableCell>
// // //                         <TableCell>{record.amountPaid.toFixed(2)}</TableCell>
// // //                         <TableCell>{record.paymentMethod}</TableCell>
// // //                         <TableCell>{record.note}</TableCell>
// // //                         <TableCell>{record.paidBy}</TableCell>
// // //                       </TableRow>
// // //                     ))
// // //                   )}
// // //               </TableBody>
// // //             </Table>
// // //           </TableContainer>
// // //         </>
// // //       )}
// // //     </Container>
// // //   );
// // // };

// // // export default SupplierDues;

// // import React, { useState, useEffect } from 'react';
// // import { useDispatch, useSelector } from 'react-redux';
// // import { useHistory } from 'react-router-dom';
// // import { useSnackbar } from 'react-simple-snackbar';
// // import {
// //   Container,
// //   Typography,
// //   Button,
// //   TextField,
// //   FormControl,
// //   InputLabel,
// //   Select,
// //   MenuItem,
// //   Table,
// //   TableBody,
// //   TableCell,
// //   TableContainer,
// //   TableHead,
// //   TableRow,
// //   Paper,
// // //   Autocomplete,
// // } from '@material-ui/core';
// // import Autocomplete from "@material-ui/lab/Autocomplete";

// // import { makeStyles } from '@material-ui/core/styles';
// // import moment from 'moment';
// // import { getAllSuppliers } from '../../actions/supplierActions';
// // import { updatePurchase, getPurchases } from '../../actions/purchaseActions';

// // const useStyles = makeStyles((theme) => ({
// //   root: {
// //     padding: theme.spacing(3),
// //   },
// //   formControl: {
// //     margin: theme.spacing(1),
// //     minWidth: 150,
// //   },
// //   table: {
// //     minWidth: 650,
// //   },
// // }));

// // const SupplierDues = () => {
// //   const classes = useStyles();
// //   const dispatch = useDispatch();
// //   const history = useHistory();
// //   const [openSnackbar] = useSnackbar();
// //   const suppliers = useSelector((state) => state.suppliers.suppliers);
// //   const purchases = useSelector((state) => state.purchases.purchases);
// //   const [selectedSupplier, setSelectedSupplier] = useState(null);
// //   const [dueAmount, setDueAmount] = useState(0);
// //   const [paymentAmount, setPaymentAmount] = useState('');
// //   const [paymentMethod, setPaymentMethod] = useState('');
// //   const [paymentNote, setPaymentNote] = useState('');
// //   const user = JSON.parse(localStorage.getItem('profile'));

// //   useEffect(() => {
// //     dispatch(getAllSuppliers());
// //     dispatch(getPurchases());
// //   }, [dispatch]);

// //   useEffect(() => {
// //     if (selectedSupplier) {
// //       const supplierPurchases = purchases.filter(
// //         (p) => p.supplier?.id === selectedSupplier.id && p.supplierDue > 0
// //       );
// //       const totalDue = supplierPurchases.reduce((sum, p) => sum + (p.supplierDue || 0), 0);
// //       console.log('Supplier Purchases:', supplierPurchases);
// //       console.log('Total Due:', totalDue);
// //       setDueAmount(totalDue);
// //     } else {
// //       setDueAmount(0);
// //     }
// //   }, [selectedSupplier, purchases]);

// //   const handlePayment = async () => {
// //     if (!selectedSupplier || !paymentAmount || !paymentMethod) {
// //       openSnackbar('Please fill all required fields');
// //       return;
// //     }

// //     const amountToPay = parseFloat(paymentAmount);
// //     if (isNaN(amountToPay) || amountToPay <= 0 || amountToPay > dueAmount) {
// //       openSnackbar('Invalid payment amount');
// //       return;
// //     }

// //     try {
// //       let remainingPayment = amountToPay;
// //       const supplierPurchases = purchases
// //         .filter((p) => p.supplier?.id === selectedSupplier.id && p.supplierDue > 0)
// //         .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));

// //       console.log('Supplier Purchases to Update:', supplierPurchases);

// //       for (const purchase of supplierPurchases) {
// //         if (remainingPayment <= 0) break;

// //         const currentDue = purchase.supplierDue || 0;
// //         const paymentForThisPurchase = Math.min(remainingPayment, currentDue);

// //         const newPaymentRecord = {
// //           amountPaid: paymentForThisPurchase,
// //           datePaid: new Date(),
// //           paymentMethod,
// //           note: paymentNote || '',
// //           paidBy: user?.result?.name || 'Unknown',
// //         };

// //         const updatedDue = currentDue - paymentForThisPurchase;
// //         const newStatus =
// //           updatedDue === 0 ? 'Paid' : updatedDue < purchase.total ? 'Partially Paid' : 'Unpaid';

// //         const updatedPurchase = {
// //           ...purchase,
// //           supplierDue: updatedDue,
// //           status: newStatus,
// //           paymentRecords: [...(purchase.paymentRecords || []), newPaymentRecord],
// //           totalAmountReceived: (purchase.totalAmountReceived || 0) + paymentForThisPurchase,
// //         };

// //         console.log('Updating Purchase:', purchase.id, updatedPurchase);

// //         await dispatch(updatePurchase(purchase.id, updatedPurchase));
// //         remainingPayment -= paymentForThisPurchase;
// //       }

// //       // Refresh purchases to update the UI
// //       await dispatch(getPurchases());

// //       openSnackbar('Payment recorded successfully');
// //       setPaymentAmount('');
// //       setPaymentMethod('');
// //       setPaymentNote('');
// //     } catch (error) {
// //       console.error('Payment Error:', error);
// //       openSnackbar('Failed to record payment. Please try again.');
// //     }
// //   };

// //   const suppliersProps = {
// //     options: suppliers,
// //     getOptionLabel: (option) => option.name || '',
// //   };

// //   return (
// //     <Container className={classes.root}>
// //       <Typography variant="h4" gutterBottom>
// //         Supplier Dues Management
// //       </Typography>
// //       <Autocomplete
// //         {...suppliersProps}
// //         value={selectedSupplier}
// //         onChange={(event, value) => setSelectedSupplier(value)}
// //         renderInput={(params) => (
// //           <TextField {...params} label="Select Supplier" variant="outlined" />
// //         )}
// //       />
// //       {selectedSupplier && (
// //         <>
// //           <Typography variant="h6" style={{ marginTop: '20px' }}>
// //             Current Due: {dueAmount.toFixed(2)}
// //           </Typography>
// //           <TextField
// //             label="Payment Amount"
// //             type="number"
// //             value={paymentAmount}
// //             onChange={(e) => setPaymentAmount(e.target.value)}
// //             variant="outlined"
// //             style={{ marginTop: '20px', marginRight: '10px' }}
// //           />
// //           <FormControl variant="outlined" className={classes.formControl}>
// //             <InputLabel>Payment Method</InputLabel>
// //             <Select
// //               value={paymentMethod}
// //               onChange={(e) => setPaymentMethod(e.target.value)}
// //               label="Payment Method"
// //             >
// //               <MenuItem value="">
// //                 <em>Select</em>
// //               </MenuItem>
// //               <MenuItem value="Cash">Cash</MenuItem>
// //               <MenuItem value="Online">Online</MenuItem>
// //             </Select>
// //           </FormControl>
// //           <TextField
// //             label="Payment Note"
// //             value={paymentNote}
// //             onChange={(e) => setPaymentNote(e.target.value)}
// //             variant="outlined"
// //             style={{ marginTop: '20px', width: '300px' }}
// //           />
// //           <Button
// //             variant="contained"
// //             color="primary"
// //             onClick={handlePayment}
// //             style={{ marginTop: '20px', backgroundColor: '#ef7f1a' }}
// //           >
// //             Record Payment
// //           </Button>
// //           <Typography variant="h6" style={{ marginTop: '30px' }}>
// //             Payment History
// //           </Typography>
// //           <TableContainer component={Paper}>
// //             <Table className={classes.table}>
// //               <TableHead>
// //                 <TableRow>
// //                   <TableCell>Purchase ID</TableCell>
// //                   <TableCell>Date</TableCell>
// //                   <TableCell>Amount Paid</TableCell>
// //                   <TableCell>Payment Method</TableCell>
// //                   <TableCell>Note</TableCell>
// //                   <TableCell>Paid By</TableCell>
// //                 </TableRow>
// //               </TableHead>
// //               <TableBody>
// //                 {purchases
// //                   .filter((p) => p.supplier?.id === selectedSupplier.id && p.paymentRecords?.length > 0)
// //                   .flatMap((p) =>
// //                     p.paymentRecords.map((record, index) => (
// //                       <TableRow key={`${p.id}-${index}`}>
// //                         <TableCell>{p.purchaseNumber}</TableCell>
// //                         <TableCell>{moment(record.datePaid).format('MMM Do YYYY')}</TableCell>
// //                         <TableCell>{record.amountPaid.toFixed(2)}</TableCell>
// //                         <TableCell>{record.paymentMethod}</TableCell>
// //                         <TableCell>{record.note || '-'}</TableCell>
// //                         <TableCell>{record.paidBy}</TableCell>
// //                       </TableRow>
// //                     ))
// //                   )}
// //                 {purchases
// //                   .filter((p) => p.supplier?.id === selectedSupplier.id && p.paymentRecords?.length > 0)
// //                   .length === 0 && (
// //                   <TableRow>
// //                     <TableCell colSpan={6} align="center">
// //                       No payment records found
// //                     </TableCell>
// //                   </TableRow>
// //                 )}
// //               </TableBody>
// //             </Table>
// //           </TableContainer>
// //         </>
// //       )}
// //     </Container>
// //   );
// // };

// // export default SupplierDues;

// import React, { useState, useEffect } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { useHistory } from 'react-router-dom';
// import { useSnackbar } from 'react-simple-snackbar';
// import {
//   Container,
//   Typography,
//   Button,
//   TextField,
//   FormControl,
//   FormControlLabel,
//   Radio,
//   RadioGroup,
//   InputLabel,
//   Select,
//   MenuItem,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
// } from '@material-ui/core';
// import Autocomplete from "@material-ui/lab/Autocomplete";
// import { makeStyles } from '@material-ui/core/styles';
// import moment from 'moment';
// import { getAllSuppliers } from '../../actions/supplierActions';
// import { updatePurchase, getPurchases } from '../../actions/purchaseActions';

// const useStyles = makeStyles((theme) => ({
//   root: {
//     padding: theme.spacing(3),
//     backgroundColor: '#f5f5f5',
//   },
//   filterContainer: {
//     display: 'flex',
//     alignItems: 'center',
//     gap: theme.spacing(2),
//     marginBottom: theme.spacing(2),
//   },
//   formControl: {
//     margin: theme.spacing(1),
//     minWidth: 150,
//   },
//   table: {
//     minWidth: 650,
//   },
//   dialog: {
//     padding: theme.spacing(2),
//   },
//   dialogTitle: {
//     backgroundColor: '#ef7f1a',
//     color: 'white',
//     padding: theme.spacing(1),
//   },
//   radioGroup: {
//     display: 'flex',
//     flexDirection: 'row',
//     gap: theme.spacing(2),
//   },
//   submitButton: {
//     backgroundColor: '#ef7f1a',
//     color: 'white',
//     '&:hover': {
//       backgroundColor: '#d66f17',
//     },
//   },
//   tableHeader: {
//     backgroundColor: '#f5f5f5',
//     fontWeight: 500,
//   },
// }));

// const SupplierDues = () => {
//   const classes = useStyles();
//   const dispatch = useDispatch();
//   const history = useHistory();
//   const [openSnackbar] = useSnackbar();
//   const suppliers = useSelector((state) => state.suppliers.suppliers);
//   const purchases = useSelector((state) => state.purchases.purchases);
//   const [fromDate, setFromDate] = useState('');
//   const [toDate, setToDate] = useState('');
//   const [selectedFilterSupplier, setSelectedFilterSupplier] = useState(null);
//   const [dialogOpen, setDialogOpen] = useState(false);
//   const today = new Date().toISOString().split('T')[0]; // Get today's date in 'YYYY-MM-DD' format
// const [dialogDate, setDialogDate] = useState(today);
//   const [selectedSupplier, setSelectedSupplier] = useState(null);
//   const [dueAmount, setDueAmount] = useState(0);
//   const [paymentMethod, setPaymentMethod] = useState('');
//   const [paymentAmount, setPaymentAmount] = useState('');
//   const [paymentNote, setPaymentNote] = useState('');
//   const user = JSON.parse(localStorage.getItem('profile'));

//   useEffect(() => {
//     dispatch(getAllSuppliers());
//     dispatch(getPurchases());
//   }, [dispatch]);



// useEffect(() => {
//     // Reset dueAmount to 0 when the supplier changes
//     setDueAmount(0);
  
//     if (selectedSupplier) {
//       const supplierPurchases = purchases.filter(
//         (p) => p.supplier?.name === selectedSupplier.name && p.supplierDue > 0
//       );
//       const totalDue = supplierPurchases.reduce((sum, p) => sum + (p.supplierDue || 0), 0);
//       setDueAmount(totalDue);
//     }
//   }, [selectedSupplier, purchases]);

//   useEffect(() => {
//     console.log(purchases);
// }, [purchases]); 

//   const handlePayment = async () => {
//     if (!selectedSupplier || !paymentAmount || !paymentMethod) {
//       openSnackbar('Please fill all required fields');
//       return;
//     }

//     const amountToPay = parseFloat(paymentAmount);
//     if (isNaN(amountToPay) || amountToPay <= 0 || amountToPay > dueAmount) {
//       openSnackbar('Invalid payment amount');
//       return;
//     }

//     try {
//       let remainingPayment = amountToPay;
//       const supplierPurchases = purchases
//         .filter((p) => p.supplier?.id === selectedSupplier.id && p.supplierDue > 0)
//         .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));

//       for (const purchase of supplierPurchases) {
//         if (remainingPayment <= 0) break;

//         const currentDue = purchase.supplierDue || 0;
//         const paymentForThisPurchase = Math.min(remainingPayment, currentDue);

//         const newPaymentRecord = {
//           amountPaid: paymentForThisPurchase,
//           datePaid: new Date(dialogDate),
//           paymentMethod,
//           note: paymentNote || '',
//           paidBy: user?.result?.name || 'Unknown',
//         };

//         const updatedDue = currentDue - paymentForThisPurchase;
//         const newStatus =
//           updatedDue === 0 ? 'Paid' : updatedDue < purchase.total ? 'Partially Paid' : 'Unpaid';

//         const updatedPurchase = {
//           ...purchase,
//           supplierDue: updatedDue,
//           status: newStatus,
//           paymentRecords: [...(purchase.paymentRecords || []), newPaymentRecord],
//           totalAmountReceived: (purchase.totalAmountReceived || 0) + paymentForThisPurchase,
//         };

//         await dispatch(updatePurchase(purchase.id, updatedPurchase));
//         remainingPayment -= paymentForThisPurchase;
//       }

//       await dispatch(getPurchases());
//       openSnackbar('Payment recorded successfully');
//       setDialogOpen(false);
//       setPaymentAmount('');
//       setPaymentMethod('');
//       setPaymentNote('');
//       setSelectedSupplier(null);
//     } catch (error) {
//       console.error('Payment Error:', error);
//       openSnackbar('Failed to record payment. Please try again.');
//     }
//   };

//   const suppliersProps = {
//     options: suppliers,
//     getOptionLabel: (option) => option.name || '',
//   };

//   const filteredPurchases = purchases.filter((p) => {
//     const dateMatch =
//       (!fromDate || new Date(p.createdAt) >= new Date(fromDate)) &&
//       (!toDate || new Date(p.createdAt) <= new Date(toDate));
//     const supplierMatch = selectedFilterSupplier
//       ? p.supplier?.id === selectedFilterSupplier.id
//       : true;
//     return dateMatch && supplierMatch;
//   });

//   const paymentRecords = filteredPurchases
//     .filter((p) => p.paymentRecords?.length > 0)
//     .flatMap((p) =>
//       p.paymentRecords.map((record, index) => ({
//         purchaseId: p.purchaseNumber,
//         datePaid: record.datePaid,
//         amountPaid: record.amountPaid,
//         paymentMethod: record.paymentMethod,
//         note: record.note,
//         paidBy: record.paidBy,
//         recordIndex: index,
//         purchaseIdForKey: p.id,
//       }))
//     )
//     .sort((a, b) => new Date(b.datePaid) - new Date(a.datePaid)); // Sort by datePaid, latest first

//   return (
//     <Container className={classes.root}>
//       <div className={classes.filterContainer}>
//         <TextField
//           label="From"
//           type="date"
//           value={fromDate}
//           onChange={(e) => setFromDate(e.target.value)}
//           InputLabelProps={{ shrink: true }}
//           variant="outlined"
//           style={{ width: 150 }}
//         />
//         <TextField
//           label="To"
//           type="date"
//           value={toDate}
//           onChange={(e) => setToDate(e.target.value)}
//           InputLabelProps={{ shrink: true }}
//           variant="outlined"
//           style={{ width: 150 }}
//         />
//         <Autocomplete
//           {...suppliersProps}
//           value={selectedFilterSupplier}
//           onChange={(event, value) => setSelectedFilterSupplier(value)}
//           renderInput={(params) => (
//             <TextField {...params} label="Filter by Supplier" variant="outlined" style={{ width: 200 }} />
//           )}
//         />
//         <Button
//           variant="outlined"
//           onClick={() => {
//             setFromDate('');
//             setToDate('');
//             setSelectedFilterSupplier(null);
//           }}
//           style={{ marginLeft: 10 }}
//         >
//           Clear Filters
//         </Button>
//         <Button
//           variant="contained"
//           color="primary"
//           onClick={() => setDialogOpen(true)}
//           className={classes.submitButton}
//           style={{ marginLeft: 'auto' }}
//         >
//           + Payment
//         </Button>
//       </div>

//       <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
//         <DialogTitle className={classes.dialogTitle}>Add Payment</DialogTitle>
//         <DialogContent className={classes.dialog}>
//           <TextField
//             label="Date"
//             type="date"
//             value={dialogDate}
//             onChange={(e) => setDialogDate(e.target.value)}
//             InputLabelProps={{ shrink: true }}
//             variant="outlined"
//             fullWidth
//             style={{ marginBottom: 20 }}
//           />
//           <Autocomplete
//             {...suppliersProps}
//             value={selectedSupplier}
//             onChange={(event, value) => setSelectedSupplier(value)}
//             renderInput={(params) => (
//               <TextField {...params} label="Select Supplier" variant="outlined" fullWidth />
//             )}
//             style={{ marginBottom: 20 }}
//           />
//           {selectedSupplier && (
//             <Typography variant="h6" style={{ marginBottom: 20 }}>
//               Total Due Amount: ₹{dueAmount.toFixed(2)}
//             </Typography>
//           )}
//           <Typography variant="subtitle1" style={{ marginBottom: 10 }}>
//             Payment Mode
//           </Typography>
//           <FormControl component="fieldset" style={{ marginBottom: 20 }}>
//             <RadioGroup
//               value={paymentMethod}
//               onChange={(e) => setPaymentMethod(e.target.value)}
//               className={classes.radioGroup}
//             >
//               <FormControlLabel value="Cash" control={<Radio />} label="Cash" />
//               <FormControlLabel value="Online" control={<Radio />} label="Online" />
//               <FormControlLabel value="Card" control={<Radio />} label="Card" />
//             </RadioGroup>
//           </FormControl>
//           <TextField
//             label="Amount"
//             type="number"
//             value={paymentAmount}
//             onChange={(e) => setPaymentAmount(e.target.value)}
//             variant="outlined"
//             fullWidth
//             style={{ marginBottom: 20 }}
//           />
//           <TextField
//             label="Remarks"
//             value={paymentNote}
//             onChange={(e) => setPaymentNote(e.target.value)}
//             variant="outlined"
//             fullWidth
//             multiline
//             rows={2}
//             style={{ marginBottom: 20 }}
//           />
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setDialogOpen(false)} color="primary">
//             Cancel
//           </Button>
//           <Button onClick={handlePayment} className={classes.submitButton}>
//             Submit
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <TableContainer component={Paper}>
//         <Table className={classes.table}>
//           <TableHead>
//             <TableRow>
//               <TableCell className={classes.tableHeader}>Purchase ID</TableCell>
//               <TableCell className={classes.tableHeader}>Date</TableCell>
//               <TableCell className={classes.tableHeader}>Amount Paid</TableCell>
//               <TableCell className={classes.tableHeader}>Payment Method</TableCell>
//               <TableCell className={classes.tableHeader}>Note</TableCell>
//               <TableCell className={classes.tableHeader}>Paid By</TableCell>
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {paymentRecords.map((record) => (
//               <TableRow key={`${record.purchaseIdForKey}-${record.recordIndex}`}>
//                 <TableCell>{record.purchaseId}</TableCell>
//                 <TableCell>{moment(record.datePaid).format('DD MMM YYYY')}</TableCell>
//                 <TableCell>₹{(record.amountPaid || 0).toFixed(2)}</TableCell>
//                 <TableCell>{record.paymentMethod}</TableCell>
//                 <TableCell>{record.note || '-'}</TableCell>
//                 <TableCell>{record.paidBy}</TableCell>
//               </TableRow>
//             ))}
//             {paymentRecords.length === 0 && (
//               <TableRow>
//                 <TableCell colSpan={6} align="center">
//                   No payment records found
//                 </TableCell>
//               </TableRow>
//             )}
//           </TableBody>
//         </Table>
//       </TableContainer>
//     </Container>
//   );
// };

// export default SupplierDues;

import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useSnackbar } from 'react-simple-snackbar';
import {
  Container,
  Typography,
  Button,
  TextField,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  InputLabel,
  Select,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TablePagination,
} from '@material-ui/core';
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';
import { getAllSuppliers } from '../../actions/supplierActions';
import { updatePurchase, getPurchases } from '../../actions/purchaseActions';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
    backgroundColor: '#f5f5f5',
    marginLeft: "66px"
  },
  filterContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 150,
  },
  table: {
    minWidth: 650,
  },
  dialog: {
    padding: theme.spacing(2),
  },
  dialogTitle: {
    backgroundColor: '#ef7f1a',
    color: 'white',
    padding: theme.spacing(1),
  },
  radioGroup: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(2),
  },
  submitButton: {
    backgroundColor: '#ef7f1a',
    color: 'white',
    '&:hover': {
      backgroundColor: '#d66f17',
    },
  },
  tableHeader: {
    backgroundColor: '#f5f5f5',
    fontWeight: 500,
  },
}));

const SupplierDues = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const [openSnackbar] = useSnackbar();
  const suppliers = useSelector((state) => state.suppliers.suppliers);
  const purchases = useSelector((state) => state.purchases.purchases);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [selectedFilterSupplier, setSelectedFilterSupplier] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const today = new Date().toISOString().split('T')[0]; // Get today's date in 'YYYY-MM-DD' format
  const [dialogDate, setDialogDate] = useState(today);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [dueAmount, setDueAmount] = useState(0);
  const [paymentMethod, setPaymentMethod] = useState('');
  const [paymentAmount, setPaymentAmount] = useState('');
  const [paymentNote, setPaymentNote] = useState('');
  const user = JSON.parse(localStorage.getItem('profile'));
  // Pagination states
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(7);

  useEffect(() => {
    dispatch(getAllSuppliers());
    dispatch(getPurchases());
  }, [dispatch]);

  useEffect(() => {
    // Reset dueAmount to 0 when the supplier changes
    setDueAmount(0);

    if (selectedSupplier) {
      const supplierPurchases = purchases.filter(
        (p) => p.supplier?.name === selectedSupplier.name && p.supplierDue > 0
      );
      const totalDue = supplierPurchases.reduce((sum, p) => sum + (p.supplierDue || 0), 0);
      setDueAmount(totalDue);
    }
  }, [selectedSupplier, purchases]);

  const handlePayment = async () => {
    if (!selectedSupplier || !paymentAmount || !paymentMethod) {
      openSnackbar('Please fill all required fields');
      return;
    }

    const amountToPay = parseFloat(paymentAmount);
    if (isNaN(amountToPay) || amountToPay <= 0 || amountToPay > dueAmount) {
      openSnackbar('Invalid payment amount');
      return;
    }

    try {
      let remainingPayment = amountToPay;
      const supplierPurchases = purchases
        .filter((p) => p.supplier?.name === selectedSupplier.name && p.supplierDue > 0)
        .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));

      for (const purchase of supplierPurchases) {
        if (remainingPayment <= 0) break;

        const currentDue = purchase.supplierDue || 0;
        const paymentForThisPurchase = Math.min(remainingPayment, currentDue);

        const newPaymentRecord = {
          amountPaid: paymentForThisPurchase,
          datePaid: new Date(dialogDate),
          paymentMethod,
          note: paymentNote || '',
          paidBy: user?.result?.name || 'Unknown',
        };

        const updatedDue = currentDue - paymentForThisPurchase;
        const newStatus =
          updatedDue === 0 ? 'Paid' : updatedDue < purchase.total ? 'Partially Paid' : 'Unpaid';

        const updatedPurchase = {
          ...purchase,
          supplierDue: updatedDue,
          status: newStatus,
          paymentRecords: [...(purchase.paymentRecords || []), newPaymentRecord],
          totalAmountReceived: (purchase.totalAmountReceived || 0) + paymentForThisPurchase,
        };

        await dispatch(updatePurchase(purchase.id, updatedPurchase));
        remainingPayment -= paymentForThisPurchase;
      }

      await dispatch(getPurchases());
      openSnackbar('Payment recorded successfully');
      setDialogOpen(false);
      setPaymentAmount('');
      setPaymentMethod('');
      setPaymentNote('');
      setSelectedSupplier(null);
    } catch (error) {
      console.error('Payment Error:', error);
      openSnackbar('Failed to record payment. Please try again.');
    }
  };

  useEffect(() => {
      console.log("purchases data:", purchases);
    }, [purchases]);

    

  const suppliersProps = {
    options: suppliers,
    getOptionLabel: (option) => option.name || '',
  };

  const filteredPurchases = purchases.filter((p) => {
    // const dateMatch =
    //   (!fromDate || new Date(p.createdAt) >= new Date(fromDate)) &&
    //   (!toDate || new Date(p.createdAt) <= new Date(toDate));
    const supplierMatch = selectedFilterSupplier
      ? p.supplier?.name === selectedFilterSupplier.name
      : true;
    return supplierMatch;
  });
  
  const paymentRecords = filteredPurchases
    .filter((p) => p.paymentRecords?.length > 0)
    .flatMap((p) =>
      p.paymentRecords.map((record, index) => ({
        supplierName: p.supplier?.name, // Add supplier name
        purchaseId: p.purchaseNumber,
        datePaid: record.datePaid,
        amountPaid: record.amountPaid,
        paymentMethod: record.paymentMethod,
        note: record.note,
        paidBy: record.paidBy,
        recordIndex: index,
        purchaseIdForKey: p.id,
      }))
    )
    .filter((record) => {
      // Filter payment records based on datePaid
      const dateMatch =
        (!fromDate || new Date(record.datePaid) >= new Date(fromDate)) &&
        (!toDate || new Date(record.datePaid) <= new Date(toDate));
      return dateMatch;
    })
    .sort((a, b) => new Date(b.datePaid) - new Date(a.datePaid)); // Sort by datePaid, latest first

  // Pagination handlers
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const value = parseInt(event.target.value, 10);
    setRowsPerPage(value === -1 ? paymentRecords.length : value);
    setPage(0); // Reset to first page when rows per page changes
  };

  // Paginated data
  const paginatedRecords = rowsPerPage > 0
    ? paymentRecords.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
    : paymentRecords;

  return (
    <Container className={classes.root}>
      <div className={classes.filterContainer}>
        <TextField
          label="From"
          type="date"
          value={fromDate}
          onChange={(e) => setFromDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
          variant="outlined"
          style={{ width: 150 }}
        />
        <TextField
          label="To"
          type="date"
          value={toDate}
          onChange={(e) => setToDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
          variant="outlined"
          style={{ width: 150 }}
        />
        <Autocomplete
          {...suppliersProps}
          value={selectedFilterSupplier}
          onChange={(event, value) => setSelectedFilterSupplier(value)}
          renderInput={(params) => (
            <TextField {...params} label="Filter by Supplier" variant="outlined" style={{ width: 200 }} />
          )}
        />
        <Button
          variant="outlined"
          onClick={() => {
            setFromDate('');
            setToDate('');
            setSelectedFilterSupplier(null);
          }}
          style={{ marginLeft: 10 }}
        >
          Clear Filters
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={() => setDialogOpen(true)}
          className={classes.submitButton}
          style={{ marginLeft: 'auto' }}
        >
          + Payment
        </Button>
      </div>

      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        <DialogTitle className={classes.dialogTitle}>Add Payment</DialogTitle>
        <DialogContent className={classes.dialog}>
          <TextField
            label="Date"
            type="date"
            value={dialogDate}
            onChange={(e) => setDialogDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
            variant="outlined"
            fullWidth
            style={{ marginBottom: 20 }}
          />
          <Autocomplete
            {...suppliersProps}
            value={selectedSupplier}
            onChange={(event, value) => setSelectedSupplier(value)}
            renderInput={(params) => (
              <TextField {...params} label="Select Supplier" variant="outlined" fullWidth />
            )}
            style={{ marginBottom: 20 }}
          />
          {selectedSupplier && (
            <Typography variant="h6" style={{ marginBottom: 20 }}>
              Total Due Amount: ₹{dueAmount.toFixed(2)}
            </Typography>
          )}
          <Typography variant="subtitle1" style={{ marginBottom: 10 }}>
            Payment Mode
          </Typography>
          <FormControl component="fieldset" style={{ marginBottom: 20 }}>
            <RadioGroup
              value={paymentMethod}
              onChange={(e) => setPaymentMethod(e.target.value)}
              className={classes.radioGroup}
            >
              <FormControlLabel value="Cash" control={<Radio />} label="Cash" />
              <FormControlLabel value="Online" control={<Radio />} label="Online" />
              <FormControlLabel value="Card" control={<Radio />} label="Card" />
            </RadioGroup>
          </FormControl>
          <TextField
            label="Amount"
            type="number"
            value={paymentAmount}
            onChange={(e) => setPaymentAmount(e.target.value)}
            variant="outlined"
            fullWidth
            style={{ marginBottom: 20 }}
          />
          <TextField
            label="Remarks"
            value={paymentNote}
            onChange={(e) => setPaymentNote(e.target.value)}
            variant="outlined"
            fullWidth
            multiline
            rows={2}
            style={{ marginBottom: 20 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)} color="primary">
            Cancel
          </Button>
          <Button onClick={handlePayment} className={classes.submitButton}>
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      <TableContainer component={Paper}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell className={classes.tableHeader}>S.No</TableCell>
              <TableCell className={classes.tableHeader}>Supplier Name</TableCell>
              {/* <TableCell className={classes.tableHeader}>Purchase ID</TableCell> */}
              <TableCell className={classes.tableHeader}>Date</TableCell>
              <TableCell className={classes.tableHeader}>Amount Paid</TableCell>
              <TableCell className={classes.tableHeader}>Payment Method</TableCell>
              <TableCell className={classes.tableHeader}>Note</TableCell>
              <TableCell className={classes.tableHeader}>Paid By</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedRecords.map((record, index) => (
              <TableRow key={`${record.purchaseIdForKey}-${record.recordIndex}`}>
                <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                <TableCell>{record.supplierName}</TableCell>
                {/* <TableCell>{record.purchaseId}</TableCell> */}
                <TableCell>{moment(record.datePaid).format('DD MMM YYYY')}</TableCell>
                <TableCell>₹{(record.amountPaid || 0).toFixed(2)}</TableCell>
                <TableCell>{record.paymentMethod}</TableCell>
                <TableCell>{record.note || '-'}</TableCell>
                <TableCell>{record.paidBy}</TableCell>
              </TableRow>
            ))}
            {paginatedRecords.length === 0 && (
              <TableRow>
                <TableCell colSpan={8} align="center">
                  No payment records found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[7, 10, 15, 25, { label: 'All', value: -1 }]}
        component="div"
        count={paymentRecords.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Container>
  );
};

export default SupplierDues;